import {ActionBuilder} from "co-redux-builders"; 

export default ActionBuilder.build({ 
	 dispatchClearReducer: () => ({}) 
})